export function Thorvik() {
    return (<div className="structured-text">
        <div className="my-3"><b>ГАРАНТИЙНЫЕ ОБЯЗАТЕЛЬСТВА.</b></div>

        <div className="my-3"><b>1. Понятие «ОГРАНИЧЕННАЯ ГАРАНТИЯ»</b></div>

        <div>1.1 На инструмент, имеющий в своей конструкции КИНЕМАТИЧЕСКУЮ СХЕМУ (МЕХАНИЗМ) распространяется понятие
            «ограниченной гарантии», в связи с сокращенным сроком эксплуатации, связанным с повышенным износом при
            использовании и определен в 12 месяцев с начала использования в условиях эксплуатации средней интенсивности.
        </div>
        <div>1.2 При повышенной интенсивности или тяжелых условиях эксплуатации инструмента гарантийный срок может быть
            сокращен до одного месяца.
        </div>
        <div>1.3 Начало гарантийного срока, начало эксплуатации определяется по дате продажи, указанной в гарантийном
            талоне
            продавцом инструмента или документе, подтверждающим факт приобретения изделия. В отдельных случаях, при
            реализации продукции на промышленные предприятия, начало гарантийного срока может исчисляться с момента
            ввода
            инструмента в эксплуатацию, но не более 3-х месяцев с даты продажи.
        </div>
        <div className="my-3"><b>2. Исполнение гарантийных обязательств.</b></div>
        <div>2.1 Производитель гарантирует бесперебойное функционирование изделий торговой марки THORVIK® в течение
            ДЕСЯТИ
            лет с начала эксплуатации всех типов инструмента, за исключением тех групп инструмента, которые перечислены
            в п.
            2.2.
        </div>
        <div>2.2 На следующие группы слесарно-монтажного, пневматического, измерительного и т.п. распространяется
            понятие
            «ограниченная гарантия»:
        </div>
        <div>2.2.1 На изделия имеющие в своей конструкции храповый механизм (ключи гаечные трещоточные, рукоятки
            трещоточные
            и т.п.) распространяется ограниченный срок гарантии в ДВЕНАДЦАТЬ месяцев
        </div>
        <div>2.2.2 На измерительный и диагностический инструмент, включая манометры, компрессометры, тестеры, рулетки,
            динамометрические ключи, и т.п. устанавливается ограниченный срок гарантии в ДВЕНАДЦАТЬ месяцев, если не
            предусмотрен изготовителем межповерочный интервал, который зависит от интенсивности эксплуатации данного
            инструмента.
        </div>
        <div>2.2.3 На группы шарнирно-губцевого инструмента, ключей разводных и трубных рычажных, отверток с
            разнообразными
            рабочими профилями, устанавливается срок гарантийных обязательств в ДВЕНАДЦАТЬ месяцев, кроме тех случаев,
            когда
            рабочие поверхности потеряли свою функциональность вследствие естественного износа.
        </div>
        <div>2.2.4 Пневмомеханический инструмент, включая элементы пневмоподготовки и покрасочное оборудование, попадает
            под
            действие «ограниченной гарантии», срок которой определен в ДВЕНАДЦАТЬ месяцев.
        </div>
        <div>2.2.5 Аккумуляторный инструмент, включая аккумуляторные батареи попадает под действие «ограниченной
            гарантии»,
            срок которой определен в ДВЕНАДЦАТЬ месяцев.
        </div>
        <div>2.2.6 На специальный инструмент, включающий съемники универсальные, съемники для шарнирных соединений,
            стяжки,
            зажимные приспособления, оборудование для замены консистентных смазок и т.п. а также на специализированный
            инструмент для обслуживания отдельных марок транспортных средств, определяется гарантийный срок в ДВЕНАДЦАТЬ
            месяцев.
        </div>
        <div>2.2.7 На инструментальную мебель (верстаки и инструментальные тележки) распространяется ограниченный срок
            гарантии в ДВЕНАДЦАТЬ месяцев.
        </div>
        <div>2.3 Производитель обеспечивает ремонт или замену по гарантийным обязательствам в следующих случаях:</div>
        <div>2.3.1 Брак материала, из которого изготовлено изделие;</div>
        <div>2.3.2 Брак, допущенный при изготовлении изделия или вследствие нарушения технологического процесса
            (раковины в
            литье, неоднородность материала и т.п.);
        </div>
        <div>2.3.3 Нарушение технологического процесса, а именно: брак при термической (твердость не соответствует
            стандарту) и гальванической технологических операциях (брак покрытия);
        </div>
        <div>2.3.4 Брак, допущенный при механической обработке или сборки изделия (дефект рабочей части, рабочий профиль
            изделия не соответствует заявленному, нарушение геометрических параметров, тела изделия, чехлов рукояток,
            нарушение геометрических параметров, брак при маркировке инструмента, нарушение геометрических параметров,
            привод или присоединительный профиль не соответствует заявленному, брак фиксирующего или храпового механизма
            и
            т.п.)
        </div>
        <div>2.4 При проведении ремонтных работ инструмента по гарантийным обязательствам, гарантийный срок не меняется
            и
            исчисляется с момента первичной даты приобретения или ввода изделия в эксплуатацию (см. п. 1.3). На
            устанавливаемые, в процессе гарантийного или постгарантийного ремонта, детали и ремонтные комплекты
            распространяется ограниченный срок гарантии в ОДИН месяц с момента передачи готового изделия потребителю.
        </div>
        <div>2.5 В случае полной замены изделия по гарантийным обязательствам, гарантийный срок исчисляется с момента
            передачи нового инструмента потребителю.
        </div>
        <div className="my-3"><b>3. Отказ в предоставлении услуг по гарантийным обязательствам.</b></div>
        <div>3.1 Нарушение правил эксплуатации гаечных ключей, а именно: наращивание дополнительного рычага (труба,
            другой
            ключ и т.п.), превышение предельно допустимой нагрузки, ударные воздействия на тело ключа (исключая ударные
            накидные односторонние ключи), неправильный подбор ключа по размеру и профилю, воздействия, не связанные с
            основным предназначением ключа.
        </div>
        <div>3.2 Нарушение правил эксплуатации торцевых головок, а именно: превышение предельно допустимой нагрузки.
            Использование торцевых головок для механизированного инструмента с ручным приводом и наоборот. Использование
            ударных воздействий на тело головки, неправильный подбор инструмента по размеру и профилю, воздействия, не
            связанные с основным предназначением торцевой головки.
        </div>
        <div>3.3 Нарушение правил эксплуатации трещоточных рукояток, воротков, переходников, шарниров и других изделий,
            входящих в группу «ПРИВОДЫ», а именно: наращивание дополнительного рычага в виде трубы или какого-нибудь
            другого
            изделия. Превышение предельно допустимой нагрузки, ударные воздействия на тело изделия, воздействия, не
            связанные с основным предназначением данного типа инструмента. Использование трещоточных рукояток, карданных
            шарниров, гибких удлинителей и удлинителей с шаром для первичного ослабления сильно нагруженных резьбовых
            соединений. При использовании понижающих переходников прилагаемое усилие должно быть рассчитано исходя из
            значений для меньшего размера привода. Использование удлинителей, переходников и шарнирных карданов для
            механизированного инструмента с ручным приводом и наоборот. Попытка проведения самостоятельного ремонта, а
            также
            использование неоригинальных запасных частей и комплектующих.
        </div>
        <div>3.4 Нарушение правил эксплуатации инструмента для работы с внутренним профилем, а именно: использование
            стержневых отверток и торцевых ключей в качестве монтировок, рычагов, выколоток или зубил, фиксирующих
            пальцев и
            т.п. Наращивание дополнительного рычага в виде трубы или какого-нибудь другого изделия при работе с
            торцевыми
            ключами. Превышение предельно допустимой нагрузки, ударные воздействия на тело изделия (кроме изделий,
            имеющих
            соответствующие конструкционные особенности), воздействия, не связанные с основным предназначением
            инструмента,
            неправильный подбор инструмента по размеру и профилю. Использование насадок с вставками-битами для
            механизированного инструмента с ручным приводом и наоборот. Переточка износившихся и деформированных рабочих
            частей инструментов. Вставки-биты являются расходным материалом, применяемом при массовом производстве,
            гарантийные условия производителя на них не распространяется, равно как и на торцевые насадки (головки с
            вставками-битами, составные и цельные), ударные и для ручного привода.
        </div>
        <div>3.5 Нарушение правил эксплуатации шарнирно-губцевого инструмента, а именно: использование не по назначению
            и
            неправильный подбор инструмента, использование режущих поверхностей инструмента для обработки материалов и
            поверхностей, не подходящих по твердости и размерам, а также использование для удержания предметов,
            подвергающихся высокотемпературной обработке (кроме изделий, имеющих конструкционные особенности).
            Наращивание
            дополнительного рычага в виде трубы или какого-нибудь другого изделия для увеличения усилия сжатия, а также
            использование инструмента в качестве ударного. Превышение предельно допустимой нагрузки, ударные воздействия
            на
            тело и рукоятки изделия, воздействия, не связанные с основным предназначением инструмента, падение изделия с
            высоты на твердую поверхность. Попытка восстановить или переточить износившиеся и деформированные рабочие
            части
            инструментов.
        </div>
        <div>3.6 Для инструментов режущего, ударного и ударно-режущего действия, срок поддержания гарантийных
            обязательств
            не предусмотрен, за исключением случаев первичного выявления дефектов, делающих использование инструмента
            невозможным и являющихся следствием нарушения технологических процессов при производстве. Детали изделий,
            изготовленные из природных материалов, обслуживанию по гарантийным условиям не подлежат.
        </div>
        <div>3.7 Нарушение правил транспортировки, а также постоянное или периодическое хранение инструмента в условиях
            высокой влажности или иных агрессивных к материалам изделия средах может привести к отказу в обслуживании по
            гарантийным обязательствам производителя.
        </div>
        <div>3.8 Обслуживание по гарантийным условиям производителя не предоставляется в случае невозможности
            идентификации
            предусмотренных серийных номеров изделий и документов, подтверждающих приобретение и начало эксплуатации
            изделий, относящихся по гарантийным условиям к инструментам с ограниченным гарантийным сроком.
        </div>


        <div className="my-3"><b>4. ДОПОЛНИТЕЛЬНАЯ ИНФОРМАЦИЯ</b></div>
        <div>4.1 Претензии по данной гарантии также не принимаются к рассмотрению в случаях невозможности подтверждения
            квалификации пользователя, наличия признаков проведения ремонтных работ изделий, осуществлявшихся
            неуполномоченными на это лицами, изменения конструкции, или самостоятельной установки неоригинальных
            компонентов
            и деталей изделий.
        </div>
        <div>4.2 Производитель (продавец) оставляет за собой право определения причины выхода из строя изделия (из-за
            некачественных материалов, ошибок при сборке, человеческого фактора или по иным причинам).
        </div>
        <div>4.3 Претензии потребителей к инструменту, вышедшему из строя в течение гарантийного срока, принимаются к
            рассмотрению в соответствии с Законом «О защите прав потребителей».
        </div>
        <div>4.4 В случае обнаружения неисправности, Вы можете обратиться в региональные представительства или
            авторизованные сервисные центры торговых марок THORVIK®
        </div>

    </div>)
}